/*
 * Stellar — One ticket per event (cart enforcement)
 * --------------------------------------------------
 * Events (product_type === 'Social Outing') are limited to a single ticket.
 * The quantity UI is already locked in snippets/quantity-selector.liquid and on the
 * custom event page (hidden quantity=1). This script is the bypass-proof backstop:
 * after ANY cart mutation it re-reads the real cart and forces every event line
 * back to quantity 1. This catches manipulated /cart/add or /cart/change calls
 * (URL params, dev tools, AJAX), re-adds, and the native /cart page.
 *
 * Non-event products are never touched, so merch / gift cards keep working normally.
 */
(function () {
  'use strict';

  var EVENT_TYPE = 'Social Outing';
  var MAX_PER_EVENT = 1;
  var busy = false; // re-entrancy guard so our own corrective call isn't re-processed

  function getCart() {
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  // Returns an { lineItemKey: 1 } map for any event line above the limit, or null.
  function buildUpdates(cart) {
    var updates = {};
    var needed = false;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item && item.product_type === EVENT_TYPE && item.quantity > MAX_PER_EVENT) {
        updates[item.key] = MAX_PER_EVENT;
        needed = true;
      }
    }
    return needed ? updates : null;
  }

  // Re-sync visible UI after a correction actually happened.
  function refreshUI() {
    // Native /cart page: reload so steppers, line totals and subtotal re-render.
    if (window.location.pathname.indexOf('/cart') === 0) {
      window.location.reload();
      return;
    }
    // Custom slide-in drawer: if it is open, re-render it from the corrected cart.
    // Small delay so we win any in-flight render from the add handler.
    setTimeout(function () {
      var drawer = document.getElementById('stel-drawer');
      if (drawer && drawer.classList.contains('open') && typeof window.stelOpenCart === 'function') {
        try { window.stelOpenCart(); } catch (e) {}
      }
    }, 60);
  }

  function enforce() {
    if (busy) return Promise.resolve();
    busy = true;
    return getCart()
      .then(function (cart) {
        var updates = buildUpdates(cart);
        if (!updates) { busy = false; return; }
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updates })
        })
          .then(function (r) { return r.json(); })
          .then(function () { busy = false; refreshUI(); });
      })
      .catch(function () { busy = false; });
  }

  // Reconcile after every cart-mutating fetch (add / change / update / clear).
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function () {
      var url = '';
      try {
        var input = arguments[0];
        url = (typeof input === 'string') ? input : (input && input.url) || '';
      } catch (e) {}
      var isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
      var promise = nativeFetch.apply(this, arguments);
      if (isCartMutation && !busy) {
        promise.then(function () { enforce(); }, function () {});
      }
      return promise;
    };
  }

  // Catch state that already exists on load, full-page-navigation adds
  // (e.g. GET /cart/add?id=...&quantity=2 which redirects to /cart), and bfcache restores.
  function init() { enforce(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) enforce(); });
})();
